import React, { useState } from 'react';
import { Image } from 'react-bootstrap'

import { ButtonLightRed, PlayerPopup } from '../../../components';
import classes from './sectionRegister.module.css';

function HowtoRegister() {
  const [showVideo, setShowVideo] = useState(false);
  const [source, setSource] = useState('');

  const openPlayer = (open, path) => {
    setSource(`${process.env.REACT_APP_VIDEOS_CDN_URL}${path}`)
    setShowVideo(open)
  }
  return (

    <div className={classes.mainContentRegister}>
      {
        showVideo &&
        <PlayerPopup
          close={() => openPlayer(false)}
          show={showVideo}
          source={source}
        />
      }
      <div className={classes.headerRegister}>
        <h1 className="main-text">¡Registrarse es muy fácil!</h1>
        <p className="desc-text">Sigue estos pasos para empezar a disfrutar <br /> Claro Pay en tu celular.</p>
      </div>

      <div className={classes.mainImage}>
        <Image className={classes.imageRegister} src="images/como-registrarse-claro-pay.png" fluid />
        <div className={classes.contentButton}>
          <ButtonLightRed
            onClick={() => openPlayer(true, '/registrar/ComoRegistrarse.mp4')}>
            Ver video
          </ButtonLightRed>
        </div>
      </div>
    </div>
  );
}

export default HowtoRegister;